//
export const isEmpty = (obj: any): boolean =>
  [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length

export const isNil = (value: any): boolean => value === null || value === undefined

export const isNanValue = (value: any): boolean => typeof value === 'number' && isNaN(value)
